export default __webpack_public_path__ + "static/media/106.62fb2516.png";